import { gql } from '@apollo/client'

export default gql(`
    mutation updateConfig( $id: ID! $isEnabled: Boolean $project: String) {
        updateConfig(
            input: {
                id: $id
                isEnabled: $isEnabled
            }
            project: $project
        ) {
            id
            name
            isEnabled
        }
    }`
)
